// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_E_r","cls2":"PodcastLibraryCarouselAd-cls2_dFi PodcastLibraryCarouselAd-cls1_E_r"};